import { SYSTEM_FIELD_NAMES } from '@cli-constants/schema.js'

export function validateGeneratedFieldName(name: string): string[] {
  const errors: string[] = []
  if (!/^[A-Za-z][A-Za-z0-9_]*$/.test(name)) {
    errors.push(
      `Field name "${name}" is invalid. Use letters, numbers, and underscores, starting with a letter.`
    )
  }

  if (SYSTEM_FIELD_NAMES.has(name)) {
    errors.push(`Field name "${name}" is reserved by BetterStart.`)
  }

  return errors
}
